import React from 'react';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import { ICON_ARROW_BLACK } from 'assets/icons';

interface NavigateFormIProps {
  icon: any;
  title: string | React.ReactElement;
  badgeContent?: React.ReactElement;
  iconStyle?: React.CSSProperties;
  onClick: () => void;
}

const NavigateForm: React.FC<NavigateFormIProps> = props => {
  const { icon, title, badgeContent, iconStyle, onClick } = props;

  return (
    <Row
      gap="16px"
      justifyContent="space-between"
      style={{ width: '100%', cursor: 'pointer' }}
      onClick={onClick}
    >
      <Row gap="12px">
        <img
          src={icon}
          alt="navigation icon"
          style={{ width: '18px', height: '18px', ...iconStyle }}
        />
        <Text color="#414B56" size="16px" weight={400}>
          {title}
        </Text>
      </Row>
      <Row gap="12px">
        {badgeContent && badgeContent}
        {/* <img src={ICON_ARROW_BLACK} alt="navigation icon" /> */}
      </Row>
    </Row>
  );
};

export default NavigateForm;
